<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Run Rates and Dates Audit</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="report-button" class="action-button"
            [disabled]="selectedScenarios?.length === 0 || highRunRate < 1 || highRunRate > 999" (click)="getReport()">
      Run Report
    </button>
  </div>
</div>
<div class="d-flex flex-column gap-8">
  <div class="d-flex flex-column justify-content-center">
    <mat-button-toggle-group [(ngModel)]="selectedSourceType"
                             (ngModelChange)="onSourceChange()"
                             hideSingleSelectionIndicator="true"
                             class="flex max-width">
      <mat-button-toggle id="forecast-org-toggle" [value]="0" class="equal-flex-item">
        By Forecast Org
      </mat-button-toggle>
      <mat-button-toggle id="global-scenario-toggle" [value]="1" class="equal-flex-item">
        By Global Scenario
      </mat-button-toggle>
      <mat-button-toggle id="tvp-toggle" [value]="2" class="equal-flex-item">
        By TVP Scenarios
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="content-height">
    <app-global-scenario-select-component
      [memberScenarioType]="0"
      [filterNonGM]="false"
      [user]="stateService.getUserGmid()"
      (confirmEvent)="selectGlobalScenario($event)"
      *ngIf="selectedSourceType === 1">
    </app-global-scenario-select-component>
    <app-vehicle-scenario-select
      titleText="Select Vehicle Scenario"
      [isMultiSelect]="true"
      (confirmEvent)="selectScenarios($event)"
      *ngIf="selectedSourceType === 0">
    </app-vehicle-scenario-select>
    <app-vehicle-scenario-select
      titleText="Select TVP Scenario"
      [isMultiSelect]="true"
      [validFcorgs]="['GMTVP']"
      (confirmEvent)="selectScenarios($event)"
      *ngIf="selectedSourceType === 2">
    </app-vehicle-scenario-select>
  </div>
  <div class="d-flex flex-row gap-8 align-items-center">
    <mat-form-field subscriptSizing="dynamic"
                    matTooltip="Low Run Rate Tolerance will equal 1 divided by the selected high tolerance">
      <mat-label class="asterisk--before">High Run Rate</mat-label>
      <input [min]="1" [max]="999" [(ngModel)]="highRunRate" type="number" matInput>
      <mat-icon matSuffix>%</mat-icon>
    </mat-form-field>
    <div class="d-flex gap-8 flex-row justify-content-center ">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="startYear" id="startYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="endYear" id="endYear">
          <mat-option *ngFor="let year of yearRange" [value]="year">{{ year }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex flex-row gap-8">
      <mat-checkbox [(ngModel)]="aggregateTos" id="aggregate-tos">Aggregate Type of Sale</mat-checkbox>
      <mat-checkbox [(ngModel)]="removeRecidNa" id="remove-na">Remove [RECID = NA] Records</mat-checkbox>
    </div>

  </div>
</div>
